export const config = {
    SERVICE_URL: process.env.REACT_APP_IDENTITY_SERVICE_URL,
    ISSUER: process.env.REACT_APP_OIDC_ISSUER, // https://optimizelyapp.oktapreview.com/oauth2/default
    CLIENT_ID: process.env.REACT_APP_OIDC_CLIENT_ID, // User Management app: 0oa1aupcsrm9rTnP10h8
    REDIRECT_URI: window.location.origin + process.env.REACT_APP_OIDC_CALLBACK_PATH,
    SCOPE: process.env.REACT_APP_OIDC_SCOPE ? JSON.parse(process.env.REACT_APP_OIDC_SCOPE) : [],
    PKCE: process.env.REACT_APP_OIDC_PKCE === "true",
    RESPONSE_TYPE: process.env.REACT_APP_OIDC_RESPONSE_TYPE
        ? JSON.parse(process.env.REACT_APP_OIDC_RESPONSE_TYPE)
        : ["code"],
    DATADOG_APP_ID: process.env.REACT_APP_DATADOG_APP_ID,
    APP_ENVIRONMENT: process.env.REACT_APP_ENV || "local",
    DATADOG_CLIENT_TOKEN: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    // Direct-region auth (EU data residency), gated by the enable_eu flag. Only the EU
    // side needs new config: ISSUER/CLIENT_ID above already ARE the NA issuer and NA SPA
    // client, so the NA leg of clientIdForIssuer reuses them and flag-off is a no-op.
    OIDC_EU_ISSUER: process.env.REACT_APP_OIDC_EU_ISSUER,
    OIDC_EU_CLIENT_ID: process.env.REACT_APP_OIDC_EU_CLIENT_ID,
    // Base URL of the auth broker that resolves a user's region. The /resolve and
    // /login paths are derived from it — see lib/region-auth.
    BROKER_URL: process.env.REACT_APP_BROKER_URL
};
